import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "menu-list" }
const _hoisted_2 = { class: "team-jump" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "highlight-header section-header" }, " Team Results ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "section-header" }, [
  /*#__PURE__*/_createElementVNode("i", null, "Team Member Results")
], -1)

import { ref } from "vue";
import TandemFloatingMenu from "@/components/TandemFloatingMenu.vue";
import TeamEvaluationTeamResults from "@/components/TeamEvaluationTeamResults.vue";
import TeamEvaluationMemberResults from "@/components/TeamEvaluationMemberResults.vue";
import { APITeam } from "@/services/teamService";


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamEvaluationTeamTabContent',
  props: {
    cohortId: {},
    cohortSurveyId: {},
    team: {}
  },
  setup(__props: any) {



const teamResults = ref<InstanceType<typeof TeamEvaluationTeamResults> | null>(
  null
);
const memberResults = ref<InstanceType<typeof TeamEvaluationMemberResults>[]>(
  []
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TandemFloatingMenu, null, {
      header: _withCtx(() => [
        _createTextVNode(" Jump-To ")
      ]),
      content: _withCtx(() => [
        _createElementVNode("ul", _hoisted_1, [
          _createElementVNode("li", _hoisted_2, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (teamResults.value?.$el.scrollIntoView({ block: 'start', behavior: 'smooth' })))
            }, " Team ")
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(memberResults.value, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.props.memberId
            }, [
              _createElementVNode("a", {
                onClick: ($event: any) => (item.$el.scrollIntoView({ block: 'start', behavior: 'smooth' }))
              }, _toDisplayString(item.props.memberName), 9, _hoisted_3)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _hoisted_4,
    (_openBlock(), _createBlock(TeamEvaluationTeamResults, {
      ref_key: "teamResults",
      ref: teamResults,
      class: "results-section",
      key: _ctx.team.id,
      "cohort-id": _ctx.cohortId,
      "cohort-survey-id": _ctx.cohortSurveyId,
      "team-id": _ctx.team.id
    }, null, 8, ["cohort-id", "cohort-survey-id", "team-id"])),
    _hoisted_5,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.team.cohort_members, (member) => {
      return (_openBlock(), _createBlock(TeamEvaluationMemberResults, {
        key: member.id,
        "cohort-id": _ctx.cohortId,
        "cohort-survey-id": _ctx.cohortSurveyId,
        "member-id": member.id,
        "member-name": member.name,
        class: "member-results",
        ref_for: true,
        ref_key: "memberResults",
        ref: memberResults
      }, null, 8, ["cohort-id", "cohort-survey-id", "member-id", "member-name"]))
    }), 128))
  ], 64))
}
}

})